"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_OVERRIDEABLE_FIELDS = void 0;
var DEFAULT_OVERRIDEABLE_FIELDS = ['jsonType', 'type', 'name', 'title', 'description', 'options', 'fieldsets', 'validation', 'readOnly', 'hidden', 'inputComponent', 'diffComponent', 'initialValue'];
exports.DEFAULT_OVERRIDEABLE_FIELDS = DEFAULT_OVERRIDEABLE_FIELDS;